<template>
    <AuthLayout>
        <!--        <div-->
        <!--            class="mt-8 flex w-full flex-col items-center overflow-hidden bg-white p-6 shadow-xl sm:mt-14 sm:max-w-md sm:rounded-lg"-->
        <!--        >-->
        <!--            <div class="-mt-1 h-[240px] w-[240px]">-->
        <!--                <img-->
        <!--                    srcset="-->
        <!--                        https://d5aoblv5p04cg.cloudfront.net/application/images/auth/forgotten-confirmation.png-->
        <!--                    "-->
        <!--                    class="ml-[10px] mt-[10px] h-full w-full"-->
        <!--                    alt="Rhizom Illustration"-->
        <!--                />-->
        <!--            </div>-->

        <!--            <div class="mt-[14px] text-xl font-bold text-gray-800">-->
        <!--                {{ $t("vue.all_good") }}-->
        <!--            </div>-->

        <!--            <div class="mt-3 max-w-sm text-center text-sm text-gray-500">-->
        <!--                {{ $t("vue.new_password_set_sign_in") }}-->
        <!--            </div>-->

        <!--            <div class="mb-3 mt-9 w-full">-->
        <!--                <inertia-link :href="route('login')">-->
        <!--                    <MegaButton>{{ $t("vue.sign_in") }}</MegaButton>-->
        <!--                </inertia-link>-->
        <!--            </div>-->
        <!--        </div>-->

        <div
            class="flex w-full flex-col items-center bg-white px-6 pb-6 sm:max-w-[344px]"
        >
            <div class="flex justify-center">
                <img
                    :src="checkOk"
                    alt="Dmarceye profile password has been reset"
                    title="Dmarceye profile password has been set"
                    :class="['block mx-auto mb-12', `w-458px]`, `h-276px]`]"
                />
            </div>

            <div
                class="mt-6 text-center text-3xl font-bold leading-9 text-[#161E2E]"
            >
                {{ $t("vue.all_good") }}
            </div>

            <div
                class="mt-6 max-w-[344px] text-center text-[12.25px] font-normal leading-[1.42] text-black"
            >
                {{ $t("vue.new_password_set_sign_in") }}
            </div>

            <div class="mt-6 w-full">
                <inertia-link :href="route('login')" class="block w-full">
                    <MegaButton
                        class="w-full !rounded-md !bg-[#088BEA] !py-3 !text-sm !font-medium !text-white !shadow-none hover:!bg-[#067DD2] focus:!ring-0"
                    >
                        {{ $t("vue.sign_in_again") }}
                    </MegaButton>
                </inertia-link>
            </div>
        </div>
    </AuthLayout>
</template>

<script lang="ts" setup>
import route from "ziggy-js";

const checkOk = new URL(
    "/resources/js/assets/images/speech-bubble-check.svg",
    import.meta.url,
).href;
</script>
